import React, { FC } from 'react';
import { Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Form from '~/components/WizardForm';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import Section from '~/layouts/Section ';

const n = (namePath: string | string[]) => ['demoTest'].concat([namePath].flat());

const DemoTest: FC = () => {
  const { t } = useTranslation('fillApplication');

  return (
    <Container className="Addresses">
      <Form payloadKey="demoTest">
        <Typography.Title>{t('Address')}</Typography.Title>
        <Section formItemLast>
          <Typography.Title level={4}>{t('Head office').toUpperCase()}</Typography.Title>
          <Typography.Paragraph>
            {t(
              'This must be the location where you will take payments and where we can reach you.'
            )}
          </Typography.Paragraph>
          <InputsGroupLayout>
            <Form.Item label={t('Account name')} name={n(['demoTest', 'companyName'])}>
              <Input  />
            </Form.Item>
          </InputsGroupLayout>
        </Section>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  .Addresses-Checkbox {
    margin-bottom: 16px;
  }
`;

export default DemoTest;
